<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
      
          <h3>Selected Fields of Campaigns</h3>
        </vs-col>


        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <DataGrid :context="'SelectedFieldsofCampaigns'" 
         :rowSelection="'single'"
        ref="campaigns"
        :columnDefs="campaignsColumnDefs"
        :rowData="campaignsRecords"
        :dataSource="campaignsDataSource"
        @showCampaignSelectedFields="showCampaignSelectedFields"
        @updateCampaignSelectedFields="updateCampaignSelectedFields"
      >
      </DataGrid>
    </vx-card>
    <vs-popup
      fullscreen
      class="holamundo"
      title="Campaign Selected Fields"
      :active.sync="showCampaignSelectedFieldsPopUp"
    >
 

      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Master Fields</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>

      <DataGrid :context="'MasterCampaignFields'" 
      :rowSelection="'single'"
        ref="MasterCampaignFields"
        :columnDefs="getMasterCampaignFieldColumns"
        :rowData="campaignMasterFieldsRecords"
        :dataSource="campaignMasterFieldsDataSource"
      >
      </DataGrid>
      <vs-row vs-w="12" class="m-4 mt-10">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Client Fields</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>

      <DataGrid :context="'ClientCampaignFields'" 
      :rowSelection="'single'"
        ref="ClientCampaignFields"
        :columnDefs="getClientCampaignColumns"
        :rowData="campaignClientFieldsRecords"
        :dataSource="campaignClientFieldsDataSource"
      >
      </DataGrid>
      <vs-row vs-w="12" class="m-4 mt-10">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Campaign Fields</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>

      <DataGrid :context="'CampaignSelectedFields'" 
      :rowSelection="'single'"
        ref="CampaignSelectedFields"
        :columnDefs="getCampaignFieldColumns"
        :rowData="campaignFieldsRecords"
        :dataSource="campaignFieldsDataSource"
      >
      </DataGrid>
      <vs-row vs-w="12" class="m-4 mt-10">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Opportunity Fields</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>

      <DataGrid :context="'OpportunityFields'" 
      :rowSelection="'single'"
        ref="OpportunityFields"
        :columnDefs="getOpportunityFieldColumns"
        :rowData="opportunityFieldsRecords"
        :dataSource="opportunityFieldsDataSource"
      >
      </DataGrid>
           <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Account Core Fields</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>

      <DataGrid :context="'AccountCoreCampaignFields'" 
      :rowSelection="'single'"
        ref="AccountCoreCampaignFields"
        :columnDefs="getAccountCoreCampaignFieldColumns"
        :rowData="campaignAccountCoreFieldsRecords"
        :dataSource="campaignAccountCoreFieldsDataSource"
      >
      </DataGrid>

      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Contact Core Fields</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>

      <DataGrid :context="'ContactCoreCampaignFields'" 
      :rowSelection="'single'"
        ref="ContactCoreCampaignFields"
        :columnDefs="getContactCoreCampaignFieldColumns"
        :rowData="campaignContactCoreFieldsRecords"
        :dataSource="campaignContactCoreFieldsDataSource"
      >
      </DataGrid>
    </vs-popup>
  </div>
</template>

<script>
var revanueValueFormatter = function(params) {
  return JSON.parse(params.data.selected_column)
  // return '$' + params.value
};
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignFieldsManagement from "@/store/fields-management/campaign-fields-management/moduleCampaignFieldsManagement.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
import JsonExcel from "vue-json-excel";
export default {
  data: () => ({
    showCampaignSelectedFieldsPopUp: false,
    abilities: null,
    campaignAccountCoreFieldsDataSource: {},
    campaignAccountCoreFieldsRecords: [],
    campaignContactCoreFieldsDataSource: {},
    campaignContactCoreFieldsRecords: [],
    campaignsColumnDefs: [
      {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: "DownloadExcelRendererActions",
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 100
      },
      {
        headerName: "Campaign",
        field: "campaign_name",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Campaign Code",
        field: "campaign_code",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Campaign Id",
        field: "campaign_id",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        valueFormatter: function(params) {
          return '_' + params.value.replaceAll("-", "_");
        }
      },
      {
        headerName: "Start Date",
        field: "start_date",
        flex: 1,

        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "End Date",
        field: "end_date",
        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    getAccountCoreCampaignFieldColumns: [
      {
        headerName: "Campaign",
        field: "campaign_name",
        width: 400,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Name",
        field: "name",
        width: 400,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Description",
        field: "description",
        width: 400,

        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Type",
        field: "type",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Value",
        field: "values",
        width: 450,

        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Sales Developer Access",
        field: "sales_developer_access",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Mandatory",
        field: "is_mandatory",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    getContactCoreCampaignFieldColumns: [
      {
        headerName: "Campaign",
        field: "campaign_name",
        width: 400,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Name",
        field: "name",
        width: 400,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Description",
        field: "description",
        width: 400,

        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Type",
        field: "type",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Value",
        field: "values",
        width: 450,

        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Sales Developer Access",
        field: "sales_developer_access",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Mandatory",
        field: "is_mandatory",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    // getAccountCoreCampaignFieldColumns: [
    //   {
    //     headerName: "Campaign",
    //     field: "campaign_name",
    //     width: 200,
    //     filter: "agTextColumnFilter",
    //     filterParams: {
    //       buttons: ["apply", "reset"],
    //       maxNumConditions: 4
    //     }
    //   },
    //   {
    //     headerName: "Name",
    //     field: "selected_column",
    //     valueFormatter: revanueValueFormatter,
    //     flex: 1,
    //     filter: "agTextColumnFilter",
    //     filterParams: {
    //       buttons: ["apply", "reset"],
    //       maxNumConditions: 4
    //     }
    //   }
    // ],
    // getContactCoreCampaignFieldColumns: [
    //   {
    //     headerName: "Campaign",
    //     field: "campaign_name",
    //     width: 200,
    //     filter: "agTextColumnFilter",
    //     filterParams: {
    //       buttons: ["apply", "reset"],
    //       maxNumConditions: 4
    //     }
    //   },
    //   {
    //     headerName: "Name",
    //     field: "selected_column",
    //     valueFormatter: revanueValueFormatter,
    //     flex: 1,
    //     filter: "agTextColumnFilter",
    //     filterParams: {
    //       buttons: ["apply", "reset"],
    //       maxNumConditions: 4
    //     }
    //   }
    // ],
    getMasterCampaignFieldColumns: [
      {
        headerName: "Campaign",
        field: "campaign_name",
        width: 400,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Name",
        field: "name",
        width: 400,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Description",
        field: "description",
        width: 400,

        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Type",
        field: "type",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Value",
        field: "values",
        width: 450,

        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Sales Developer Access",
        field: "sales_developer_access",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Mandatory",
        field: "is_mandatory",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    getClientCampaignColumns: [
      {
        headerName: "Campaign",
        field: "campaign_name",
        width: 400,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Name",
        field: "name",
        width: 400,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Description",
        field: "description",
        width: 400,

        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Type",
        field: "type",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Value",
        field: "values",
        width: 450,

        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Sales Developer Access",
        field: "sales_developer_access",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Mandatory",
        field: "is_mandatory",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    getCampaignFieldColumns: [
      {
        headerName: "Campaign",
        field: "campaign_name",
        width: 400,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Name",
        field: "name",
        width: 400,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Description",
        field: "description",
        width: 400,

        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Type",
        field: "type",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Value",
        field: "values",
        width: 450,

        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Sales Developer Access",
        field: "sales_developer_access",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Mandatory",
        field: "is_mandatory",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    getOpportunityFieldColumns: [
      {
        headerName: "Campaign",
        field: "campaign_name",
        width: 400,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Name",
        field: "name",
        width: 400,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Description",
        field: "description",
        width: 400,

        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Type",
        field: "type",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Value",
        field: "values",
        width: 450,

        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Mandatory",
        field: "is_mandatory",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    campaignMasterFieldsDataSource: {},
    campaignMasterFieldsRecords: [],
    campaignsRecords: [],
    getClientCampaignFieldDataSource: [],
    campaignClientFieldsRecords: [],
    campaignClientFieldsDataSource: [],
    campaignFieldsRecords: [],
    campaignFieldsDataSource: [],
    opportunityFieldsRecords: [],
    opportunityFieldsDataSource: [],
    selected_campaign: null,
  }),
  components: {
    "v-select": vSelect,
    moduleCampaignFieldsManagement,
    DataGrid,
    downloadExcel: JsonExcel,
  },
  watch: {},
  methods: {
    showCampaignSelectedFields(value) {
      this.showCampaignSelectedFieldsPopUp = true;
      this.selected_campaign = value.campaign_id;

      this.$refs.AccountCoreCampaignFields.gridApi.refreshServerSide({purge : true});
      this.getCampaignAccountCoreFieldsDataSource();

      this.$refs.ContactCoreCampaignFields.gridApi.refreshServerSide({purge : true});
      this.getCampaignContactCoreFieldsDataSource();

      this.$refs.MasterCampaignFields.gridApi.refreshServerSide({purge : true});
      this.getCampaignMasterFieldsDataSource();

      this.$refs.ClientCampaignFields.gridApi.refreshServerSide({purge : true});
      this.getCampaignClientFieldsDataSource();

      this.$refs.CampaignSelectedFields.gridApi.refreshServerSide({purge : true});
      this.getCampaignFieldsDataSource();

      this.$refs.OpportunityFields.gridApi.refreshServerSide({purge : true});
      this.getOpportunityFieldsDataSource();
    },
    updateCampaignSelectedFields(value) {
      this.$router.push({ path: "/campaigns/edit-more-field/" + value.campaign_id });
    },


    getCampaignAccountCoreFieldsDataSource() {
      var self = this;
      this.campaignAccountCoreFieldsDataSource = {
        getRows(params) {
          params.request.selected_campaign = self.selected_campaign;
          self.$store
            .dispatch(
              "CampaignFieldsManagement/getSelectedAccountCoreCampaignField",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;

              console.log("Account  Core Fields" , response_data)
              if (response_data.length != 0) {
                self.$refs.AccountCoreCampaignFields.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.AccountCoreCampaignFields.gridApi.showNoRowsOverlay();
                params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    getCampaignContactCoreFieldsDataSource() {
      var self = this;
      this.campaignContactCoreFieldsDataSource = {
        getRows(params) {
          params.request.selected_campaign = self.selected_campaign;

          self.$store
            .dispatch(
              "CampaignFieldsManagement/getSelectedContactCoreCampaignField",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.ContactCoreCampaignFields.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.ContactCoreCampaignFields.gridApi.showNoRowsOverlay();
                params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    getCampaignMasterFieldsDataSource() {
      var self = this;
      this.campaignMasterFieldsDataSource = {
        getRows(params) {
          params.request.selected_campaign = self.selected_campaign;

          self.$store
            .dispatch(
              "CampaignFieldsManagement/getSelectedMasterCampaignField",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.MasterCampaignFields.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.MasterCampaignFields.gridApi.showNoRowsOverlay();
                params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    getCampaignClientFieldsDataSource() {
      var self = this;
      this.campaignClientFieldsDataSource = {
        getRows(params) {
          params.request.selected_campaign = self.selected_campaign;

          self.$store
            .dispatch(
              "CampaignFieldsManagement/getSelectedClientCampaignField",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              // console.log("Client" , response_data)
              if (response_data.length != 0) {
                self.$refs.ClientCampaignFields.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.ClientCampaignFields.gridApi.showNoRowsOverlay();
                params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    getCampaignFieldsDataSource() {
      var self = this;
      this.campaignFieldsDataSource = {
        getRows(params) {
          params.request.selected_campaign = self.selected_campaign;

          self.$store
            .dispatch(
              "CampaignFieldsManagement/getSelectedCampaignField",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.CampaignSelectedFields.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.CampaignSelectedFields.gridApi.showNoRowsOverlay();
                params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    getOpportunityFieldsDataSource() {
      var self = this;
      this.opportunityFieldsDataSource = {
        getRows(params) {
          params.request.selected_campaign = self.selected_campaign;

          self.$store
            .dispatch(
              "CampaignFieldsManagement/getSelectedOpportunityField",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.OpportunityFields.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.OpportunityFields.gridApi.showNoRowsOverlay();
                params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    getcampaignDataSource() {
      var self = this;

      this.campaignsDataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "campaignsManagement/getAllCampaignsForGridForSelectedFields",
              params.request
            )
            .then(function(response) {

              console.log("Campaigns", response);


              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.MasterCampaignFields.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.MasterCampaignFields.gridApi.showNoRowsOverlay();
                params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    this.getCampaignAccountCoreFieldsDataSource();
    this.getCampaignContactCoreFieldsDataSource()
    this.getCampaignMasterFieldsDataSource();
    this.getCampaignClientFieldsDataSource();
    this.getCampaignFieldsDataSource();
    this.getOpportunityFieldsDataSource();
    this.getcampaignDataSource();
  },
  mounted() {},
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleCampaignFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "CampaignFieldsManagement",
        moduleCampaignFieldsManagement
      );
      moduleCampaignFieldsManagement.isRegistered = true;
    }
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}

.dwnload_button{
  display: none;
}

</style>

<style lang="stylus">
.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
